module.exports = "<symbol id=\"tt-icon-next-arrow\" viewBox=\"0 0 24 24\"><path d=\"M18.25 10.53L9.89 2.11 12 0l12 12-12 12-2.11-2.11 8.36-8.42H0v-2.94h18.25z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/next-arrow.svg
// module id = 211
// module chunks = 9